import { useState } from "react";
import dayjs from "dayjs";
import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUmbrellaBeach } from "@fortawesome/free-solid-svg-icons";
import { getHolidayRatesNeededQuery } from "@src/util/query/holiday.query";
import { HolidayRatesModal } from "./holidayRates.modal";
import { useTenantFeatureFlags } from "@src/hooks/useTenantFeatureFlags";

/**
 * Dashboard notice: approved holidays this month whose employee has no pay rate of their own,
 * so a manager needs to set one before payroll. Same look as the data quality banner next to
 * it. Shows nothing for people without access to employees (the query is refused).
 */
export const HolidayRatesNotice = () => {
    // only for roles that can set the rates (Employee modify) - others would just be refused
    const permission = useSelector((state) => state.userAuthReducer?.authenticatedUserDetail?.permission);
    // and only for companies with the Annual Leave module
    const { holidayEnabled } = useTenantFeatureFlags();
    const canSetRates = holidayEnabled && permission?.Employee?.access !== false && permission?.Employee?.modify !== false;
    const { data, refetch } = useQuery(getHolidayRatesNeededQuery, { variables: { employeeId: null }, fetchPolicy: "network-only", skip: !canSetRates });
    const [open, setOpen] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const result = data?.getHolidayRatesNeeded?.response;
    const count = result?.items?.length || 0;
    if (!count || dismissed) return null;

    const daysLeft = dayjs(result.until).diff(dayjs().startOf("day"), "day");
    return (
        <>
            <div className="data-health-banner" style={{ background: "#fffaf0", borderColor: "#f5dfae" }} onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon={faUmbrellaBeach} style={{ fontSize: "15px", color: "#d69e2e", flexShrink: 0 }} />
                <span className="data-health-banner-text">
                    <b>{count}</b> approved leave request{count === 1 ? "" : "s"} up to {dayjs(result.until).format("DD/MM/YYYY")} require{count === 1 ? "s" : ""} a holiday pay rate before payroll
                    {daysLeft >= 0 && daysLeft <= 7 && <> — <b>month end in {daysLeft} day{daysLeft === 1 ? "" : "s"}</b></>}
                </span>
                <span className="data-health-banner-action" style={{ color: "#b7791f" }}>Set Pay Rates</span>
                <button
                    className="data-health-banner-close"
                    onClick={(e) => { e.stopPropagation(); setDismissed(true); }}
                    title="Dismiss for now"
                >
                    <CloseOutlined style={{ fontSize: "12px" }} />
                </button>
            </div>
            <HolidayRatesModal visible={open} close={() => setOpen(false)} onSaved={() => refetch()} />
        </>
    );
};
